import { Item, ProfileImportResult, Section, SectionType } from '~/services/types/import';

export const getImportTypeDescription = (type: SectionType | string): string => {
    var key = '';

    switch (type) {
        case SectionType.Overview:
            key = 'overview';
            break;
        case SectionType.Languages:
            key = 'languages';
            break;
        case SectionType.Education:
            key = 'education';
            break;
        case SectionType.WorkExperience:
            key = 'workExperience';
            break;
        case SectionType.Memberships:
            key = 'memberships';
            break;
        case SectionType.Summary:
            key = 'summary';
            break;
    }

    return `profile.import.sectionNames.${key}`;
};

export const getImportErrorDescription = (error: any): string => {
    if (error?.response) {
        if (error.response.status === 404) {
            return 'profile.import.errors.profileNotFound';
        } else if (error.response.status === 429) {
            return 'profile.import.errors.limitReached';
        } else {
            return 'profile.import.errors.serverError';
        }
    } else {
        return 'profile.import.errors.serverError';
    }
};

const setResolvedForItem = (item: Item, value: boolean): void => {
    // Set isAction of the current item to true
    item.resolved = value;

    // Check nested items if they exist
    if (item.items) {
        for (let nestedItem of item.items) {
            setResolvedForItem(nestedItem, value);
        }
    }
};

export const setAllItemsResolved = (items: Item[], value: boolean): void => {
    for (let item of items) {
        setResolvedForItem(item, value);
    }
};

export const setAllSectionItemsResolved = (sections: Section[], value: boolean): void => {
    for (let section of sections) {
        setAllItemsResolved(section.items, value);
    }
};

const itemHasResolved = (item: Item, value: boolean): boolean => {
    if (item.resolved === value) return true;

    if (item.items) {
        for (let nestedItem of item.items) {
            if (itemHasResolved(nestedItem, value)) {
                return true;
            }
        }
    }

    return false;
};

export const anyItemHasResolved = (items: Item[], value: boolean): boolean => {
    for (let item of items) {
        if (itemHasResolved(item, value)) {
            return true;
        }
    }
    return false;
};

export const itemNeedAttentionNoRecursion = (item: Item): boolean => {
    // Check if the item has an action true and it is not yet resolved
    if (item.isAction === true && item.resolved === false) return true;

    return false;
};

export const itemNeedAttention = (item: Item): boolean => {
    if (itemNeedAttentionNoRecursion(item)) return true;

    if (item.items) {
        for (let nestedItem of item.items) {
            // Recursively check if the nested item or any of its nested items need attention
            if (itemNeedAttention(nestedItem)) {
                return true;
            }
        }
    }

    return false;
};

export const anyItemNeedAttention = (items: Item[]): boolean => {
    if (items) {
        for (let item of items) {
            if (itemNeedAttention(item)) {
                return true;
            }
        }
    }
    return false;
};

export const itemHasAction = (item: Item): boolean => {
    if (item.isAction) return true;

    if (item.items) {
        for (let nestedItem of item.items) {
            // Recursively check if the nested item or any of its nested items need attention
            if (itemHasAction(nestedItem)) {
                return true;
            }
        }
    }

    return false;
};

export const anyItemHasAction = (items: Item[]): boolean => {
    if (items) {
        for (let item of items) {
            if (itemHasAction(item)) {
                return true;
            }
        }
    }
    return false;
};

export const anySectionNeedAttention = (sections: Section[]): boolean => {
    for (let section of sections) {
        if (anyItemNeedAttention(section.items)) return true;
    }
    return false;
};

export const showLastImport = (value: ProfileImportResult | undefined | null): boolean => {
    return value !== undefined && value !== null && value.reviewedAt === null;
};
